/*
 * Copyright (c) 2025, Gather
 * https://gather.life
 */

import type { CurrencyConfig } from './number.interface';

export const currencyFormatter = (value: string | number, config?: CurrencyConfig): string => {
  const number = typeof value === 'string' ? parseFloat(value) : value;

  const formatter = new Intl.NumberFormat(config?.locale ?? 'en-US', {
    currency: config?.currency ?? 'USD',
    maximumFractionDigits: config?.maximumFractionDigits ?? 2,
    minimumFractionDigits: config?.minimumFractionDigits ?? 2,
    style: 'currency',
    trailingZeroDisplay: config?.trailingZeroDisplay ?? 'auto',
  });

  return formatter.format(number);
};
